import { Link } from 'react-router-dom';

import ViewAll from '@ifit/mp-view-all';

export default ViewAll(Link);
